export default __webpack_public_path__ + "e6a227be4a8a6f63a4f7e7bbb3dab005.png";